import { useMemo } from 'react';

export const DOTS = '...';

const range = (start: number, end: number) => {
  const length = end - start + 1;
  return Array.from({ length }, (_, index) => index + start);
};

interface PaginationProps {
  totalResultsCount: number;
  resultsPerPage: number;
  currentPage: number;
  noOfPagesToShow: number;
}

export const usePagination = ({
  totalResultsCount,
  resultsPerPage,
  currentPage,
  noOfPagesToShow
}: PaginationProps) => {
  const siblingCount = 1;
  const paginationRange = useMemo(() => {
    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    const rightSiblingIndex = Math.min(
      currentPage + siblingCount,
      noOfPagesToShow
    );

    const firstPageIndex = 1;

    if (currentPage < 5 && noOfPagesToShow > 5) {
      const ranges = range(firstPageIndex, 5);
      return [...ranges];
    }

    if (currentPage >= 5 && noOfPagesToShow > 5) {
      const middleRange = range(leftSiblingIndex, rightSiblingIndex);
      return [firstPageIndex, DOTS, ...middleRange];
    }

    if (noOfPagesToShow <= 5) {
      const leftItemCount = noOfPagesToShow * siblingCount;
      const ranges = range(firstPageIndex, leftItemCount);
      return [...ranges];
    }

    return null;
  }, [totalResultsCount, resultsPerPage, currentPage]);

  return paginationRange;
};
